/**
 * Display labels for SlideSite enum for the Specimen & Patient Information dialog.
 * Order matches the UI design (left base → right/left transition zone, then Other).
 */
import { BlockId, SlideSite, SpecimenType } from 'src/types';

export const SLIDE_SITE_OPTIONS: { value: SlideSite; label: string }[] = [
  { value: SlideSite.LeftBase, label: 'Left base' },
  { value: SlideSite.LeftMid, label: 'Left mid' },
  { value: SlideSite.LeftApex, label: 'Left apex' },
  { value: SlideSite.LeftPosteriorLateral, label: 'Left posterior lateral' },
  { value: SlideSite.LeftPosteriorMedial, label: 'Left posterior medial' },
  { value: SlideSite.LeftPeripheralZone, label: 'Left peripheral zone' },
  {
    value: SlideSite.LeftAnterolateralAnteromedial,
    label: 'Left anterolateral/anteromedial',
  },
  { value: SlideSite.RightBase, label: 'Right base' },
  { value: SlideSite.RightMid, label: 'Right mid' },
  { value: SlideSite.RightApex, label: 'Right apex' },
  { value: SlideSite.RightPosteriorLateral, label: 'Right posterior lateral' },
  { value: SlideSite.RightPosteriorMedial, label: 'Right posterior medial' },
  { value: SlideSite.RightPeripheralZone, label: 'Right peripheral zone' },
  {
    value: SlideSite.RightAnterolateralAnteromedial,
    label: 'Right anterolateral/anteromedial',
  },
  { value: SlideSite.LeftLateralBase, label: 'Left Lateral Base' },
  { value: SlideSite.LeftLateralMid, label: 'Left Lateral Mid' },
  { value: SlideSite.LeftLateralApex, label: 'Left Lateral Apex' },
  { value: SlideSite.LeftTransitionZone, label: 'Left Transition Zone' },
  { value: SlideSite.RightLateralBase, label: 'Right Lateral Base' },
  { value: SlideSite.RightLateralMid, label: 'Right Lateral Mid' },
  { value: SlideSite.RightLateralApex, label: 'Right Lateral Apex' },
  { value: SlideSite.RightTransitionZone, label: 'Right Transition Zone' },
  { value: SlideSite.Other, label: 'Other' },
];

export function getSlideSiteOptionsForSpecimenType(
  specimenType: SpecimenType,
): { value: SlideSite; label: string }[] {
  switch (specimenType) {
    case SpecimenType.ProstateBiopsy:
    case SpecimenType.MetastaticProstateBiopsy:
      return SLIDE_SITE_OPTIONS;
    case SpecimenType.ProstatePostRp:
      return [{ value: SlideSite.Other, label: 'Other' }];
    default:
      throw new Error(
        `Unsupported specimen type for slide sites: ${specimenType}`,
      );
  }
}

export const BLOCK_ID_OPTIONS: { value: BlockId; label: string }[] = [
  BlockId.A,
  BlockId.B,
  BlockId.C,
  BlockId.D,
  BlockId.E,
  BlockId.F,
  BlockId.G,
  BlockId.H,
  BlockId.I,
  BlockId.J,
  BlockId.K,
  BlockId.L,
  BlockId.M,
  BlockId.N,
  BlockId.O,
  BlockId.P,
  BlockId.Q,
  BlockId.R,
  BlockId.S,
  BlockId.T,
  BlockId.U,
  BlockId.V,
  BlockId.W,
  BlockId.X,
  BlockId.Y,
  BlockId.Z,
].map((value) => ({ value, label: value }));
